import React from 'react';

import { translate } from '~l10n/client';

import { useSubscriptions } from '~teacher/hook/useSubscriptions';

import CloseX from '../../../shared/components/buttons/CloseX';
import InfoIcon from '../../../shared/icons/InfoIcon';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const Constants = require('../../../../shared/Constants');

interface Props {
  controller: { closeClicked: () => void; renewNowClicked: () => void };
  model: { type: string; expirationDateFormatted: string };
}
export default function RenewalView({ model, controller }: Props) {
  const subscriptionsQuery = useSubscriptions();

  if (subscriptionsQuery.isLoading) {
    return null;
  }

  // this message appears for expired licenses so if there are any
  // subscriptions, this message is no longer relevant.
  if (subscriptionsQuery.data.length > 0) {
    return null;
  }

  // on the post purchase page it might be waiting for the subscription to be
  // by stripe created. So it wouldn't make sense to show this.
  const location = window?.location?.hash;
  if (location === '#post-purchase') {
    return null;
  }

  const message =
    model.type === Constants.PRO_ENDING
      ? translate('Your PRO access will expire on')
      : translate('Your PRO access expired on');

  return (
    <div
      id="renewal-notify"
      className={model.type === Constants.PRO_ENDING ? '' : 'expired'}
    >
      <InfoIcon className="info-renewal-icon" />
      <div className="renewal-content clearfix">
        <div>
          <span>
            <strong>{`${message} ${model.expirationDateFormatted}.`}</strong>
          </span>
          <CloseX
            className="close-renewal-icon align-right"
            onClick={controller.closeClicked}
          />
          <div className="actions-container clearfix">
            <button
              className="renew-now-button align-right"
              onClick={controller.renewNowClicked}
            >
              {translate('Renew Now!')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
